module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/propertiesregister/propertiesregister-list/propertiesregister-list.component.css
// module id = ./src/app/planning/propertiesregister/propertiesregister-list/propertiesregister-list.component.css
// module chunks = main